'use strict';

exports.__esModule = true;
exports.mapStateToProps = mapStateToProps;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _suggestions = require('./categories/suggestions');

var _suggestions2 = _interopRequireDefault(_suggestions);

var _facets = require('./categories/facets');

var _facets2 = _interopRequireDefault(_facets);

var _services = require('./categories/services');

var _services2 = _interopRequireDefault(_services);

var _default = require('./categories/default');

var _default2 = _interopRequireDefault(_default);

var _filter = require('../../constants/filter');

var _filter2 = _interopRequireDefault(_filter);

var _keyCodes = require('../../constants/key-codes');

var _keyCodes2 = _interopRequireDefault(_keyCodes);

var _searchResults = require('./search-results.scss');

var _searchResults2 = _interopRequireDefault(_searchResults);

var _actionCreators = require('../../store/action-creators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    filterValue: _propTypes2.default.string.isRequired,
    setSearchQuery: _propTypes2.default.func.isRequired,
    onSearch: _propTypes2.default.func.isRequired,
    searchQuery: _propTypes2.default.string,
    allResults: _propTypes2.default.array,
    apps: _propTypes2.default.array,
    marketplace: _propTypes2.default.array,
    suggest: _propTypes2.default.array,
    services: _propTypes2.default.array.isRequired,
    contentTypes: _propTypes2.default.array.isRequired,
    count: _propTypes2.default.number.isRequired,
    setResultHighlight: _propTypes2.default.func.isRequired,
    setResultSelection: _propTypes2.default.func.isRequired,
    highlightIndex: _propTypes2.default.number,
    resultUrl: _propTypes2.default.string,
    savedQuery: _propTypes2.default.string
};

var defaultProps = {
    searchQuery: '',
    allResults: [],
    apps: [],
    marketplace: [],
    suggest: [],
    highlightIndex: -1,
    resultUrl: '',
    savedQuery: ''
};

var SearchResults = function (_React$PureComponent) {
    _inherits(SearchResults, _React$PureComponent);

    function SearchResults(props) {
        _classCallCheck(this, SearchResults);

        var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

        _this.handleKeyPressed = _this.handleKeyPressed.bind(_this);
        _this.getContainerRect = _this.getContainerRect.bind(_this);
        _this.scrollIntoView = _this.scrollIntoView.bind(_this);
        _this.refCallback = _this.refCallback.bind(_this);
        return _this;
    }

    SearchResults.prototype.componentDidMount = function componentDidMount() {
        document.addEventListener('keydown', this.handleKeyPressed, false);
    };

    SearchResults.prototype.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyPressed, false);
    };

    // TODO: Remove tight coupling between offsets and order of results


    SearchResults.prototype.getOffsets = function getOffsets() {
        var _props = this.props,
            suggest = _props.suggest,
            services = _props.services,
            allResults = _props.allResults,
            marketplace = _props.marketplace;

        var suggestOffset = 0;
        var allOffset = suggestOffset + suggest.length;
        var marketplaceOffset = this.props.filterValue === _filter2.default.MARKETPLACE || this.props.filterValue === _filter2.default.PROVIDERS || this.props.filterValue === _filter2.default.ADVISORS ? 0 : allResults.length + allOffset;
        var servicesOffset = marketplaceOffset + marketplace.length;
        var contentTypesOffset = servicesOffset + services.length;

        return {
            suggestOffset: suggestOffset,
            allOffset: allOffset,
            servicesOffset: servicesOffset,
            contentTypesOffset: contentTypesOffset,
            marketplaceOffset: marketplaceOffset
        };
    };

    SearchResults.prototype.getContainerRect = function getContainerRect() {
        return this.node.getBoundingClientRect();
    };

    SearchResults.prototype.scrollIntoView = function scrollIntoView(offset) {
        this.node.scrollTop += offset;
    };

    SearchResults.prototype.refCallback = function refCallback(node) {
        this.node = node;
    };

    SearchResults.prototype.searchByQuery = function searchByQuery(query) {
        var _props2 = this.props,
            onSearch = _props2.onSearch,
            setSearchQuery = _props2.setSearchQuery;

        setSearchQuery(query);
        onSearch(query);
    };

    SearchResults.prototype.handleKeyPressed = function handleKeyPressed(e) {
        if (e.keyCode === _keyCodes2.default.ARROW_UP) {
            e.preventDefault();
            if (this.props.highlightIndex > 0) {
                this.props.setResultHighlight(this.props.highlightIndex - 1);
            } else {
                this.props.setResultHighlight(-1);
                this.props.setResultSelection(this.props.savedQuery);
            }
        }

        if (e.keyCode === _keyCodes2.default.ARROW_DOWN) {
            e.preventDefault();
            if (this.props.highlightIndex < this.props.count - 1) {
                this.props.setResultHighlight(this.props.highlightIndex + 1);
            }
        }

        if (e.keyCode === _keyCodes2.default.ENTER) {
            if (this.props.highlightIndex > -1 && this.props.resultUrl) {
                // only intercept if result is not a search term
                e.preventDefault();
                window.open(this.props.resultUrl);
            }
        }
    };

    SearchResults.prototype.render = function render() {
        var _this2 = this;

        var _props3 = this.props,
            searchQuery = _props3.searchQuery,
            filterValue = _props3.filterValue,
            allResults = _props3.allResults,
            marketplace = _props3.marketplace,
            suggest = _props3.suggest,
            services = _props3.services,
            contentTypes = _props3.contentTypes;


        var showSuggestResults = suggest.length > 0 && filterValue === _filter2.default.ALL;
        var showAllResults = allResults.length > 0;
        var showMarketplaceResults = marketplace.length > 0 && (filterValue === _filter2.default.ALL || filterValue === _filter2.default.MARKETPLACE || filterValue === _filter2.default.PROVIDERS || filterValue === _filter2.default.ADVISORS);
        var showServiceResults = services.length > 0 && filterValue === _filter2.default.ALL;
        var showContentTypeResults = contentTypes.length > 0 && filterValue === _filter2.default.ALL;

        var _getOffsets = this.getOffsets(),
            suggestOffset = _getOffsets.suggestOffset,
            allOffset = _getOffsets.allOffset,
            servicesOffset = _getOffsets.servicesOffset,
            contentTypesOffset = _getOffsets.contentTypesOffset,
            marketplaceOffset = _getOffsets.marketplaceOffset;

        return _react2.default.createElement(
            'div',
            { style: { position: 'relative' } },
            _react2.default.createElement(
                'div',
                {
                    className: _searchResults2.default.container,
                    ref: this.refCallback,
                    'data-auto-container': 'results:list'
                },
                [showSuggestResults && _react2.default.createElement(_suggestions2.default, {
                    key: 'suggest',
                    results: suggest,
                    onClick: function onClick(query) {
                        _this2.searchByQuery(query);
                    },
                    searchQuery: this.props.searchQuery,
                    offset: suggestOffset,
                    highlightIndex: this.props.highlightIndex,
                    savedQuery: this.props.savedQuery,
                    setResultSelection: this.props.setResultSelection,
                    getContainerRect: this.getContainerRect,
                    scrollIntoView: this.scrollIntoView
                }), showAllResults && _react2.default.createElement(_default2.default, {
                    key: 'all',
                    results: allResults,
                    offset: allOffset,
                    highlightIndex: this.props.highlightIndex,
                    savedQuery: this.props.savedQuery,
                    setResultSelection: this.props.setResultSelection,
                    getContainerRect: this.getContainerRect,
                    scrollIntoView: this.scrollIntoView
                }), showMarketplaceResults && _react2.default.createElement(_default2.default, {
                    key: 'catResultMarket',
                    icon: 'cart',
                    results: marketplace,
                    offset: marketplaceOffset,
                    highlightIndex: this.props.highlightIndex,
                    savedQuery: this.props.savedQuery,
                    setResultSelection: this.props.setResultSelection,
                    getContainerRect: this.getContainerRect,
                    scrollIntoView: this.scrollIntoView
                }), showServiceResults && _react2.default.createElement(_services2.default, {
                    key: 'catResult',
                    results: services,
                    searchQuery: searchQuery,
                    onClick: function onClick(query) {
                        _this2.searchByQuery(query);
                    },
                    offset: servicesOffset,
                    highlightIndex: this.props.highlightIndex,
                    savedQuery: this.props.savedQuery,
                    setResultSelection: this.props.setResultSelection,
                    getContainerRect: this.getContainerRect,
                    scrollIntoView: this.scrollIntoView
                }), showContentTypeResults && _react2.default.createElement(_facets2.default, {
                    key: 'catResultType',
                    results: contentTypes,
                    searchQuery: searchQuery,
                    onClick: function onClick(query) {
                        _this2.searchByQuery(query);
                    },
                    offset: contentTypesOffset,
                    highlightIndex: this.props.highlightIndex,
                    savedQuery: this.props.savedQuery,
                    setResultSelection: this.props.setResultSelection,
                    getContainerRect: this.getContainerRect,
                    scrollIntoView: this.scrollIntoView
                })].filter(function (result) {
                    return !!result;
                }).reduce(function (memo, result, i) {
                    return [].concat(memo, [i === 0 ? result : _react2.default.createElement(
                        'div',
                        {
                            key: result.key
                        },
                        _react2.default.createElement('hr', { className: _searchResults2.default.divider }),
                        result
                    )]);
                }, [])
            )
        );
    };

    return SearchResults;
}(_react2.default.PureComponent);

SearchResults.propTypes = propTypes;
SearchResults.defaultProps = defaultProps;

function mapStateToProps(state) {
    return {
        highlightIndex: state.highlightIndex,
        resultUrl: state.resultUrl,
        savedQuery: state.savedQuery
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    setResultHighlight: _actionCreators.setResultHighlight,
    setResultSelection: _actionCreators.setResultSelection
})(SearchResults);